import type { BadgeType, UserType } from "../types";
import Badges from "./badges";

interface RightSidebarProps {
  badges: BadgeType[];
  badgesCount: number;
  user: UserType;
}

export default function RightSidebar({
  badges,
  badgesCount,
  user,
}: RightSidebarProps) {
  return (
    <>
      {!!badges.length && (
        <Badges badges={badges} count={badgesCount} username={user.username} />
      )}
    </>
  );
}
